import PropTypes from "prop-types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/pagination";
import "swiper/css/navigation";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";

const Testimonial_Frame = ({ className = "" }) => {
  return (
    // <div
    //   className={`absolute top-[2430px] left-[157px] w-[1633px] h-[849px] overflow-hidden text-left text-11xl text-gray-100 font-istok-web ${className}`}
    // >
    //   {/* Testimonial heading section */}
    //   <div className="absolute top-[0px] left-[486px] w-[632px] flex flex-col items-center justify-start gap-[52px] text-center">
    //     <b className="self-stretch relative leading-[100%] uppercase">
    //       Testimonials
    //     </b>
    //     <div className="self-stretch relative text-[35px] capitalize text-gray-100">
    //       <span className="leading-[100%]">
    //         <span>Read what Clients</span>
    //         <b className="font-istok-web text-deepskyblue-200"> say</b>
    //         <span>{` about `}</span>
    //       </span>
    //       <span>
    //         <span className="leading-[123%]">our work</span>
    //       </span>
    //     </div>
    //   </div>

    //   <div className="absolute top-[150px] left-[0px] w-[1606px] h-[449px] overflow-hidden">
    //     {/* <div className="absolute top-[3px] left-[819px] shadow-[0px_10px_6.8px_rgba(0,_0,_0,_0.25)] rounded-11xl bg-gray-400 w-[787px] h-[446px]">
    //       <b className="absolute top-[346px] left-[614px] leading-[100%] uppercase inline-block w-[100px] h-[52px]">
    //         –
    //       </b>
    //       <div className="absolute top-[58px] left-[53px] leading-[130%] capitalize text-gray-200 inline-block w-[681px] [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">
    //         We've worked with StaffSurge for over 2 years and they've
    //         consistently delivered top-notch candidates for our business. Their
    //         team is responsive, professional, and always goes the extra mile to
    //         understand our culture and find the perfect fit.
    //       </div>
    //     </div> */}
    //     <div className="absolute top-[0px] left-[0px] shadow-[0px_10px_6.8px_rgba(0,_0,_0,_0.25)] rounded-11xl bg-gray-400 w-[787px] h-[446px]">
    //       <b className="absolute top-[347px] left-[611px] leading-[100%] uppercase">{`– Rohit `}</b>
    //       <div className="absolute top-[61px] left-[57px] leading-[130%] capitalize text-gray-200 inline-block w-[681px] [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">
    //         We have had the pleasure of working with Staff Surge Consultancy on
    //         several recruitment projects, and their professionalism,
    //         understanding of our industry, and dedication to finding top talent
    //         have been outstanding. We look forward to continuing our successful
    //         collaboration with them.
    //       </div>
    //     </div>
    //   </div>
    // </div>

    <div>
      <div className="text-center font-bold text-deepskyblue-200 text-12xl mt-12">
        TESTIMONIALS
      </div>

      <div className="text-center text-black text-6xl mt-4">
        Read what Clients{" "}
        <span className="font-bold text-deepskyblue-200">Say</span> about our
        work
      </div>

      <div className="mx-auto shadow-[0px_10px_6.8px_rgba(0,_0,_0,_0.25)] rounded-11xl bg-gray-400 mt-8">
        {/* <div className="swiper-button-prev swiper-arrow">
          <FiChevronLeft />
        </div>
        <div className="swiper-button-next swiper-arrow">
          <FiChevronRight />
        </div> */}

        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={30}
          slidesPerView={"auto"}
          loop={true}
          pagination={{
            clickable: true,
            dynamicBullets: true,
          }}
          navigation={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          className="h-full grid grid-cols-1 lg:grid-cols-2"
        >
          <SwiperSlide>
            <div className="text-11xl flex flex-col justify-between rounded-11xl bg-gray-400 w-full h-full lg:h-[850px] relative">
              <div className=" p-8 text-gray-200 [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)] ">
                Having experienced your services firsthand, I can confidently
                say that your dedication to excellence remains unwavering. The
                meticulous attention to detail, innovative approach, and
                commitment to delivering exceptional results set you apart. Your
                rebranding only reinforces your position as a leader in the
                industry, and I am excited to see the new heights you will
                reach.
              </div>

              <div className="flex flex-col items-end p-8">
                <b className="uppercase ">Jaini Gala - HR Manager</b>
                <b className="uppercase ">Aneel Lasod And Associates</b>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="text-11xl flex flex-col justify-between rounded-11xl bg-gray-400 w-full h-full lg:h-[850px] relative">
              <div className=" p-8 text-gray-200 [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)] ">
                I want to express my sincere appreciation for the outstanding HR
                consulting services you’ve provided. It’s clear that you have a
                keen eye for identifying top-tier talent. Your support has been
                very strong, and your expertise has proven to be a tremendous
                asset in helping us navigate the hiring process. You've
                consistently gone above and beyond to ensure we have the right
                people for the right roles. I am truly grateful for your support
                and resourcefulness throughout this journey with Staff Stage
              </div>

              <div className="flex flex-col items-end p-8">
                <b className="uppercase ">Vinay Chhajed - Vice President</b>
                <b className="uppercase ">Franchise Business-Bajaj Broking</b>
              </div>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div className="text-11xl flex flex-col justify-between rounded-11xl bg-gray-400 w-full h-full lg:h-[850px] relative">
              <div className=" p-8 text-gray-200 [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)] ">
                We Have Had the Pleasure of Working with Staff Surge Consultancy
                on Several Recruitment Projects, And Their Professionalism,
                Understanding of Our Industry, And Dedication to Finding Top
                Talent Have Been Outstanding. We Look Forward to Continuing Our
                Successful Collaboration with Them.
              </div>

              <div className="flex flex-col items-end p-8">
                <b className="uppercase ">Rohit Mohan Kumar - CEO & CMO </b>
                <b className="uppercase ">SARVASWA DIGITAL LLP</b>
              </div>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div className="text-11xl flex flex-col justify-between rounded-11xl bg-gray-400 w-full h-full lg:h-[850px] relative">
              <div className=" p-8 text-gray-200 [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)] ">
              Staff Surges have consistently helped us find great candidates. They’re our go-to recruiters! The team is super responsive and really understands what we’re looking for. Working with them has made hiring so much easier.
              </div>

              <div className="flex flex-col items-end p-8">
                <b className="uppercase ">Shruti Raizada- HR Executive</b>
                <b className="uppercase ">Scogo Networks</b>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </div>

      {/* <div className="shadow-[0px_10px_6.8px_rgba(0,_0,_0,_0.25)] rounded-11xl bg-gray-400 p-8 mt-8">
        <div className="capitalize text-6xl text-gray-200 inline-block [text-shadow:0px_4px_4px_rgba(0,_0,_0,_0)]">
          We have had the pleasure of working with Staff Surge Consultancy on
          several recruitment projects, and their professionalism, understanding
          of our industry, and dedication to finding top talent have been
          outstanding. We look forward to continuing our successful
          collaboration with them.
        </div>
        <div className="flex justify-end">
          <b className="uppercase">{`– Rohit `}</b>
        </div>
      </div> */}
    </div>
  );
};

Testimonial_Frame.propTypes = {
  className: PropTypes.string,
};

export default Testimonial_Frame;
